import 'css-chunk:src/dialog/dialog.module.scss';export default {
  "dialog": "dialog-module__dialog___aLWOI",
  "dialogIcon": "dialog-module__dialogIcon___SKmYt",
  "dialogTextSection": "dialog-module__dialogTextSection___Rx-K6",
  "dialogActionsSection": "dialog-module__dialogActionsSection___NVbmY",
  "dialogCloseButton": "dialog-module__dialogCloseButton___PFqhz",
  "dialog-light": "dialog-module__dialog-light___0JXxd",
  "dialog-dark": "dialog-module__dialog-dark___MkmO0"
};